var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox ai-statistics" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "18px 20px 2px" },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { size: "small", inline: "" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "时间范围：" } },
                [
                  _c("el-date-picker", {
                    staticClass: "selWidth",
                    attrs: {
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                      size: "small",
                      type: "daterange",
                      placement: "bottom-end",
                      "picker-options": _vm.pickerOptions,
                      placeholder: "全部时间",
                    },
                    on: { change: _vm.handleTimeChange },
                    model: {
                      value: _vm.timeVal,
                      callback: function ($$v) {
                        _vm.timeVal = $$v
                      },
                      expression: "timeVal",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "用户：" } },
                [
                  _c("el-input", {
                    staticClass: "selWidth",
                    attrs: {
                      placeholder: "用户ID / 昵称 / 手机号",
                      clearable: "",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.keyword,
                      callback: function ($$v) {
                        _vm.keyword = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "keyword",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.handleReset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "mt14", attrs: { gutter: 14 } },
        _vm._l(_vm.overviewCards, function (item) {
          return _c(
            "el-col",
            { key: item.key, attrs: { xs: 24, sm: 12, md: 6 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "stat-card",
                  attrs: { shadow: "never", bordered: false },
                },
                [
                  _c("div", { staticClass: "stat-card__head" }, [
                    _c("span", { staticClass: "stat-card__title" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _c("i", {
                      staticClass: "stat-card__icon",
                      class: item.icon,
                    }),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "stat-card__value",
                      style: { color: item.color },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.formatNumber(item.value))),
                      _c("span", { staticClass: "stat-card__unit" }, [
                        _vm._v(_vm._s(item.unit)),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "stat-card__extra" }, [
                    _vm._v(_vm._s(item.extra)),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        1
      ),
      _c(
        "el-card",
        { staticClass: "mt14", attrs: { shadow: "never", bordered: false } },
        [
          _c("div", { staticClass: "acea-row row-between-wrapper mb15" }, [
            _c("div", { staticClass: "header-title" }, [_vm._v("使用趋势")]),
            _c("div", { staticClass: "font12 color-999" }, [
              _vm._v(_vm._s(_vm.rangeText)),
            ]),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.overviewLoading,
                  expression: "overviewLoading",
                },
              ],
              staticClass: "trend-chart",
            },
            [
              _c("div", {
                ref: "trendChart",
                staticClass: "trend-chart__canvas",
              }),
              !_vm.overviewLoading && _vm.trendList.length === 0
                ? _c("div", { staticClass: "trend-chart__empty" }, [
                    _vm._v("所选时间范围暂无 AI 使用数据"),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "mt14", attrs: { shadow: "never", bordered: false } },
        [
          _c(
            "div",
            { staticClass: "acea-row row-between-wrapper mb15" },
            [
              _c("div", { staticClass: "header-title" }, [
                _vm._v("用户 token 消耗排名"),
              ]),
              _c(
                "el-select",
                {
                  staticStyle: { width: "110px" },
                  attrs: { size: "mini" },
                  on: { change: _vm.getRanking },
                  model: {
                    value: _vm.rankingLimit,
                    callback: function ($$v) {
                      _vm.rankingLimit = $$v
                    },
                    expression: "rankingLimit",
                  },
                },
                [
                  _c("el-option", { attrs: { value: 10, label: "TOP10" } }),
                  _c("el-option", { attrs: { value: 20, label: "TOP20" } }),
                  _c("el-option", { attrs: { value: 50, label: "TOP50" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.rankingLoading,
                  expression: "rankingLoading",
                },
              ],
              attrs: {
                data: _vm.rankingList,
                size: "mini",
                "header-cell-class-name": "tableGrayHeader",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "排名", width: "70", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "rank-badge",
                            class:
                              "rank-badge--" +
                              (scope.$index < 3 ? scope.$index + 1 : "normal"),
                          },
                          [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "用户", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "user-cell" },
                          [
                            _c(
                              "el-avatar",
                              { attrs: { size: 26, src: scope.row.avatar } },
                              [_vm._v(_vm._s((scope.row.nickname || "用")[0]))]
                            ),
                            _c("div", { staticClass: "user-cell__info" }, [
                              _c("div", { staticClass: "user-cell__name" }, [
                                _vm._v(
                                  _vm._s(scope.row.nickname || "未设置昵称")
                                ),
                              ]),
                              _c("div", { staticClass: "user-cell__uid" }, [
                                _vm._v("UID：" + _vm._s(scope.row.uid)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "所选时段 token 消耗",
                  width: "160",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.formatNumber(scope.row.rangeTokens))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "所选时段缓存命中",
                  width: "150",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: {
                              "color-999": !scope.row.rangeCachedInputTokens,
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatNumber(
                                    scope.row.rangeCachedInputTokens
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "总 token 消耗", width: "140", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.formatNumber(scope.row.totalTokens))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "占比", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.rankingRatio(scope.row),
                            "stroke-width": 8,
                            "show-text": false,
                            color: scope.$index < 3 ? "#ff7a45" : "#1890ff",
                          },
                        }),
                        _c("span", { staticClass: "font12 color-999" }, [
                          _vm._v(_vm._s(_vm.rankingRatio(scope.row)) + "%"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openChat(scope.row)
                              },
                            },
                          },
                          [_vm._v("聊天记录")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          !_vm.rankingLoading && _vm.rankingList.length === 0
            ? _c("div", { staticClass: "empty-tip" }, [
                _vm._v("暂无用户 token 消耗数据"),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "mt14", attrs: { shadow: "never", bordered: false } },
        [
          _c("div", { staticClass: "acea-row row-between-wrapper mb15" }, [
            _c("div", { staticClass: "header-title" }, [
              _vm._v("用户 AI 使用统计"),
            ]),
            _c("div", { staticClass: "font12 color-999" }, [
              _vm._v(
                "「总 token」为全部时间累计；「所选时段」相关指标跟随上方时间筛选"
              ),
            ]),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "header-cell-class-name": "tableGrayHeader",
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "用户", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "user-cell" },
                          [
                            _c(
                              "el-avatar",
                              { attrs: { size: 26, src: scope.row.avatar } },
                              [_vm._v(_vm._s((scope.row.nickname || "用")[0]))]
                            ),
                            _c("div", { staticClass: "user-cell__info" }, [
                              _c("div", { staticClass: "user-cell__name" }, [
                                _vm._v(
                                  _vm._s(scope.row.nickname || "未设置昵称")
                                ),
                              ]),
                              _c("div", { staticClass: "user-cell__uid" }, [
                                _vm._v("UID：" + _vm._s(scope.row.uid)),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "手机号",
                  width: "130",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.phone || "-"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "总 token", width: "120", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(_vm.formatNumber(scope.row.totalTokens))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "所选时段 token",
                  width: "140",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { staticClass: "color-primary" }, [
                          _vm._v(
                            _vm._s(_vm.formatNumber(scope.row.rangeTokens))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "缓存命中", width: "110", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: {
                              "color-999": !scope.row.cachedInputTokens,
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatNumber(scope.row.cachedInputTokens)
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "AI 会话", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.formatNumber(scope.row.conversationCount))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "创建活动", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.formatNumber(scope.row.activityCreateCount)
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "创建集市", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.formatNumber(scope.row.marketCreateCount))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "活动报名", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          _vm._s(_vm.formatNumber(scope.row.activityApplyCount))
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "lastActiveTime",
                  label: "最后活跃",
                  width: "160",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(scope.row.lastActiveTime || "-"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "160",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openChat(scope.row)
                              },
                            },
                          },
                          [_vm._v("聊天记录")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("chat-record-dialog", {
        attrs: {
          visible: _vm.chatVisible,
          uid: _vm.currentUser.uid,
          "user-name": _vm.currentUser.nickname,
          "start-time": _vm.tableFrom.startTime,
          "end-time": _vm.tableFrom.endTime,
        },
        on: {
          "update:visible": function ($event) {
            _vm.chatVisible = $event
          },
        },
      }),
      _c("user-detail-drawer", {
        attrs: {
          visible: _vm.detailVisible,
          uid: _vm.currentUser.uid,
          "user-name": _vm.currentUser.nickname,
          "start-time": _vm.tableFrom.startTime,
          "end-time": _vm.tableFrom.endTime,
        },
        on: {
          "update:visible": function ($event) {
            _vm.detailVisible = $event
          },
          chat: function ($event) {
            return _vm.openChat(_vm.currentUser)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }